import { createAction, props } from '@ngrx/store';
import {
  IApiCharacter,
  IApiCharacterInfo,
  IApiCharacterListResponse,
  ICharacterEnergy,
  ICharacterSkillSlot,
  ICharacterSpeciality,
} from 'src/app/api/interfaces/character.interface';
import { IApiConfigurationResponse } from 'src/app/api/interfaces/configuration.interface';
import { ICharacterCompleted } from './characterState.reducer';
export interface IUpdateCharacterSpecs {
  type: 'energy' | 'skill' | 'speciality' | 'character';
  data:
    | ICharacterCompleted
    | ICharacterEnergy
    | ICharacterSpeciality
    | ICharacterSkillSlot
    | any;
}
export const setCharacterState = createAction(
  '[State API] Get Character state success',
  props<{ responseData: IApiCharacterListResponse }>()
);
export const updateCharacterSlot = createAction(
  '[State API] success update slot',
  props<{ slot: IApiCharacterInfo }>()
);
export const updateCharacterSpecs = createAction(
  '[State API] success update CharacterSpecs',
  props<{
    character: IUpdateCharacterSpecs;
  }>()
);
export const createCompletedCharacterSlots = createAction(
  'create complete character slot',
  props<{
    configs: IApiConfigurationResponse;
  }>()
);
